import { get } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Iframe from "./Iframe";
import Prize from "./Prize";

function Knockout2() {
  const [searchParams] = useSearchParams();
  const [indexShow, setIndexShow] = useState(0);
  const pages = useMemo(() => {
    return [
      {
        page: "iframe",
        round: 2,
        element: (
          <Iframe src="https://docs.google.com/presentation/d/e/2PACX-1vSfNFifmfSJ5uJiXb9T2dty1_GvsWU4phr4ig8HRTTCjpQNr-uZSQz8_rT2x8xi3hBmW8VhcO9cCWyT/embed" />
        ),
      },
      { page: "prize", round: 5, element: <Prize /> },
    ];
  }, []);
  const pageSize = useMemo(() => pages.length, [pages]);
  const page = useMemo(() => get(pages, indexShow, null), [indexShow, pages]);
  const time = useMemo(
    () => parseInt(searchParams.get("second") ?? "10") * 1000,
    [searchParams]
  );

  useEffect(() => {
    if (page) {
      const timer = setTimeout(() => {
        setIndexShow((old) => (old + 1) % pageSize);
      }, time * (page.round ?? 0));
      return () => {
        clearTimeout(timer);
      };
    }
  }, [time, page, pageSize]);

  return page?.element ?? null;
}

export default Knockout2;
